import { Logger, EngineComponentFactory } from "neo-common";
import { ComponentTypes } from "../ComponentTypes";

/**
 * The StyleManager class is used for storing styles for canvas elements and html elements.
 * @class StyleManager
 */
export class StyleManager {
    static Styles: { [id: string]: any } = {};
    static HtmlStyles: { [id: string]: any } = {};

    static cleanup() {
        // NOTE(psulek) perf-tunning
        // - cleanup of 'StyleManager.HtmlStyles' is safe because it is used only in preloader active phase and not in runtime!
        // - do not cleanup 'StyleManager.Styles' because this is used in runtime
        StyleManager.HtmlStyles = null;
    }

    /**
     * Trace to browser console.
     * @method log
     * @param data any
     * @return void
     */
    private static log(data: any): void {
        if (DEBUG) {
            Logger.debugGroup("StyleManager", data);
        }
    }

    /**
     * Parse style elements and store them by type to static variables.
     * @method parseElements
     * @param startNode Element
     * @return void
     */
    static parseElements(startNode: Element): void {
        if (!startNode) {
            return;
        }

        const nodes: Array<Element> = StyleManager.getNodesList(startNode.firstElementChild)
            .reverse()
            .filter((node: Element) => node.hasAttribute("Class") && node.getAttribute("Class") !== "");

        nodes
            .filter((node: Element) =>
                EngineComponentFactory.isTypeOf(node.getAttribute("Class"), ComponentTypes.Style),
            )
            .forEach((node: Element) => {
                const style: any = EngineComponentFactory.get(node.getAttribute("Class"));
                style.create(node);
                StyleManager.Styles[node.nodeName] = style;
            });

        nodes
            .filter((node: Element) =>
                EngineComponentFactory.isTypeOf(node.getAttribute("Class"), ComponentTypes.HtmlStyle),
            )
            .forEach((node: Element) => {
                const style: any = EngineComponentFactory.get(node.getAttribute("Class"));
                style.create(node);
                StyleManager.HtmlStyles[node.nodeName] = style;
            });
    }

    /**
     * Recursively extracts sibling nodes.
     * @method getNodesList
     * @param node Element
     * @param nodeList Array<Element>
     * @return Array<Element>
     */
    private static getNodesList(node: Element, nodeList: Array<Element> = []): Array<Element> {
        if (!node) {
            return nodeList;
        }

        if (node.nextElementSibling) {
            nodeList = StyleManager.getNodesList(node.nextElementSibling, nodeList);
        }

        return nodeList.concat(node);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Managers/StyleManager.ts
 **/